
/* styles */
require("!!./../../../../.1.0.1@extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!./../../../../.10.3.0@vue-loader/lib/style-rewriter?id=data-v-01d812e6!./../../../../.1.0.35@vux-loader/src/style-loader.js!./../../../../.10.3.0@vue-loader/lib/selector?type=styles&index=0!./index.vue")

var Component = require("!./../../../../.10.3.0@vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!./../../../../.10.3.0@vue-loader/lib/template-compiler?id=data-v-01d812e6!./../../../../.1.0.35@vux-loader/src/template-loader.js!./../../../../.10.3.0@vue-loader/lib/selector?type=template&index=0!./index.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/.2.0.17@vux/src/components/inline-desc/index.vue
// module id = 228
// module chunks = 2